// extracted by mini-css-extract-plugin
module.exports = {"list":"SelectCustomer_list_1JO6m","item":"SelectCustomer_item_3ovU2","selected":"SelectCustomer_selected_2QUkG","options":"SelectCustomer_options_22IgP"};